import PropTypes from 'prop-types';
import { OPERATIONS_LIST } from '../../constants/Operations';
import { ScopeCategoryIcon } from '../../constants/ScopeCategoryIcon';
import ScopeHeader from './ScopeHeader';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIAccordionItem from 'UIComponents/accordion/UIAccordionItem';
import UIList from 'UIComponents/list/UIList';
import { isHighlySensitiveScope, isSensitiveScope } from '../../utils/isSensitiveScope';
import SensitiveScopeGroupWarningIcon from '../SensitiveScopeGroupWarningIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ScopeGroupCategory = ({
  category,
  defaultOpen,
  scopes
}) => {
  const renderGroupedScope = group => {
    const operationsGroup = [];
    for (const operation of OPERATIONS_LIST) {
      if (operation in scopes[group]) {
        const scope = scopes[group][operation];
        const key = `${group}-${operation}`;
        operationsGroup.push( /*#__PURE__*/_jsxs("span", {
          "data-test-id": `authorize-scope-${scope.name}`,
          children: [scope.name && isSensitiveScope(scope.name) && /*#__PURE__*/_jsx(SensitiveScopeGroupWarningIcon, {
            iconClassName: "p-right-1",
            highlySensitive: isHighlySensitiveScope(scope.name)
          }), scope.translatedDescription || scope.translatedName]
        }, key));
      }
    }
    return /*#__PURE__*/_jsx(UIList, {
      className: "m-bottom-4",
      children: operationsGroup
    }, group);
  };
  const renderGroupedScopes = () => {
    const groupedScopes = Object.keys(scopes);
    return /*#__PURE__*/_jsx("div", {
      className: "p-left-9",
      children: groupedScopes.map(gs => renderGroupedScope(gs))
    });
  };
  return /*#__PURE__*/_jsx(UIAccordionItem, {
    defaultOpen: defaultOpen,
    title: /*#__PURE__*/_jsx(ScopeHeader, {
      icon: ScopeCategoryIcon[category],
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `developer-experience-shared-components.scopesAuthorization.headings.${category}`
      })
    }),
    children: /*#__PURE__*/_jsx(UIList, {
      children: renderGroupedScopes()
    })
  });
};
ScopeGroupCategory.propTypes = {
  category: PropTypes.string.isRequired,
  defaultOpen: PropTypes.bool,
  scopes: PropTypes.object.isRequired
};
ScopeGroupCategory.defaultProps = {
  defaultOpen: false
};
export default ScopeGroupCategory;